// extracted by css-extract-rspack-plugin
export default {"errorBoundaryError":"errorBoundaryError_FiLL","errorBoundaryFallback":"errorBoundaryFallback_lv4I"};